import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import Immutable from 'immutable';

import Input from '../common/Input';
import SelectBox from '../common/SelectBox';
import DatePickerInput from '../common/DatePickerInput';
import ParentSearch from './ParentSearch';
import { relationTypes, educationLevels, occupations } from '../../constants/constants';

const ParentsForm = ({ fields, meta: { touched, error, submitFailed } }) => (
  <div className="parents-container">
    <ParentSearch fields={fields} />
    <div className="add-parents">
      <h5>PADRES</h5>
      <button
        className="add-button"
        type="button"
        onClick={() => fields.push(Immutable.Map())}
      >
        +
      </button>
    </div>
    {(touched || submitFailed) && error &&
      <span className="error-message">{error}</span>
    }
    {fields.map((parent, index) =>
      <div className="parent-form" key={index}>
        <button
          className="add-button"
          type="button"
          onClick={() => fields.remove(index)}
        >
          <i className="material-icons">
            clear
          </i>
        </button>
        <div className="multiple-fields">
          <div>
            <Field
              name={`${parent}.ci`}
              type="text"
              label="Cédula (sin puntos ni guiones)"
              component={Input}
            />
          </div>
          <div>
            <Field
              name={`${parent}.relationType`}
              label="Tipo de relación"
              options={relationTypes}
              placeholder="Madre/Padre o Tutor"
              component={SelectBox}
            />
          </div>
        </div>
        <div className="multiple-fields">
          <div>
            <Field
              name={`${parent}.firstName`}
              type="text"
              label="Nombre"
              component={Input}
            />
          </div>
          <div>
            <Field
              name={`${parent}.lastName`}
              type="text"
              label="Apellido"
              component={Input}
            />
          </div>
          <div className="multiple-fields">
            <div>
              <Field
                name={`${parent}.email`}
                type="text"
                label="Email"
                component={Input}
              />
            </div>
            <div>
              <Field
                name={`${parent}.phone`}
                type="text"
                label="Celular"
                component={Input}
              />
            </div>
          </div>
          <div className="multiple-fields">
            <div>
              <Field
                name={`${parent}.birthdate`}
                label="Fecha de nacimiento"
                showYearDropdown
                placeholder="DD/MM/AAAA"
                component={DatePickerInput}
              />
            </div>
            <div>
              <Field
                name={`${parent}.educationLevel`}
                label="Nivel educativo"
                options={educationLevels}
                component={SelectBox}
              />
            </div>
          </div>
          <div className="multiple-fields">
            <div>
              <Field
                name={`${parent}.occupation`}
                label="Ocupación actual"
                options={occupations}
                component={SelectBox}
              />
            </div>
            <div className="multiple-fields phones-field">
              <div>
                <Field
                  name={`${parent}.jobPhone`}
                  type="text"
                  label="Teléfono trabajo"
                  component={Input}
                />
              </div>
              <div>
                <Field
                  name={`${parent}.internalJobPhone`}
                  type="text"
                  label="Interno"
                  component={Input}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);

const { object } = PropTypes;

ParentsForm.propTypes = {
  fields: object,
  meta: object
};

export default ParentsForm;



// WEBPACK FOOTER //
// ./src/components/parent/ParentsForm.js